import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import useNotification from "src/hooks/useNotification";
import { createSession, getUser } from "src/slices/user";
import { fetchPermissions } from "src/slices/permission";
import jwt_decode from "jwt-decode";

const Callback = () => {
  const { user, getAccessTokenSilently } = useAuth0();
  const [sendNotification] = useNotification();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get("error") === "access_denied") {
      navigate("/");
    }
    if (!user) {
      return;
    }
    const initialCall = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        const decodedToken: any = jwt_decode(accessToken);
        // console.log("accessToken---->", accessToken);
        if (!accessToken) {
          return;
        }
        localStorage.setItem("accessToken", accessToken);
        const userId = decodedToken.sub.split("|")[1];
        localStorage.setItem("loggedUserId", userId);
        // await dispatch<any>(getUser({ userId: userId }));
        const sessionStorage = localStorage.getItem("sessionStorage");
        if (sessionStorage) {
          return;
        } else {
          let userDetails = JSON.parse(localStorage.getItem("userDetail"));
          const sessionIds = {
            token: `Bearer ${accessToken}`,
            corporate_id: userDetails?.corporate_id,
            user_id: userDetails?._id,
          };
          // const sessionStorage = {
          //   _id: "671238fc2259b70012922715",
          //   token:
          //     "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IkE0bzhkNHI1MmlIS0pWeTJ2RWZpaCJ9.eyJuaWNrbmFtZSI6InNhbWFudGhhc3JlZSIsIm5hbWUiOiJzYW1hbnRoYXNyZWVAaW5zdHJpdmUuaW4iLCJwaWN0dXJlIjoiaHR0cHM6Ly9zLmdyYXZhdGFyLmNvbS9hdmF0YXIvZDVlMDlmNWE0NWU0YmQyMzMxMDQ0YWRmZDg3OTc4ZWY_cz00ODAmcj1wZyZkPWh0dHBzJTNBJTJGJTJGY2RuLmF1dGgwLmNvbSUyRmF2YXRhcnMlMkZzYS5wbmciLCJ1cGRhdGVkX2F0IjoiMjAyNC0xMC0xOFQxMDozMToxOC45NzlaIiwiZW1haWwiOiJzYW1hbnRoYXNyZWVAaW5zdHJpdmUuaW4iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiaXNzIjoiaHR0cHM6Ly9nYWl1cy1kZXYuZXUuYXV0aDAuY29tLyIsImF1ZCI6InVWWUhXMnpwOU5IMVlCc28wREJJSFRMTGtlMGZxVUVqIiwiaWF0IjoxNzI5MjQ3NDgxLCJleHAiOjE3MjkyODM0ODEsInN1YiI6ImF1dGgwfDY1ODQxODc3ZGVmODU0YWNlMWM0NTdmZCIsImF1dGhfdGltZSI6MTcyOTI0NzQ3OCwic2lkIjoiTV82SVRRaGhnYVd6SmUteFB1NjljOXdRWjZ0aUVNVEsiLCJub25jZSI6ImJtZDVjalZLVGpGUlIyVkZaR3hGYVhCc09DNVVMV3hhVUZKd1oyTkRWR010ZEhsdFZuTXViVnBXZUE9PSJ9.X86QePwYnh_kEWy7DXvsrUSeLS8hnZrOXcjnFcHqiF9xeAvcQCQK34DwDe3omj4rnVfsJz8Mg4ahWIfocYarRE58aULDmzxWOE3L9_yJzU0VXzOa-EsXIXdjLw3YoUIHuucWWcvUZs6BFFHWCspt4TPI7ObiBoG56xtilNYaMq2TbXA5Gi3gf_O-KczVu4UZQ7njLZJ0lre-rqXVyXe-DD7igj64HJLonvCJSq7-nPHtdGJ-s2AxppAIlprafuWFqd8dPlPCJZq_yi_q1oSBEJaTLbLB56WcGiWCc1q-eAknDSqoT_phun6ZCVZaV-7X0SzgG54kp4OOT0CCvAPaHA",
          //   corporate_id: "658418550c958100132f1770",
          //   user_id: "658418550c958100132f1773",
          //   expiry_time: "2024-10-18T20:31:21.000Z",
          //   createdAt: "2024-10-18T10:31:24.961Z",
          //   updatedAt: "2024-10-18T10:31:24.961Z",
          //   __v: 0,
          // };
          let res = await dispatch<any>(createSession({ token: "" }));
          await dispatch<any>(fetchPermissions());
          if (res?.error) {
            sendNotification({
              message: res?.payload?.message,
              variant: "error",
            });
          }
          localStorage.setItem(
            "sessionStorage",
            JSON.stringify(res?.payload?.detail)
          );
          navigate("/");
        }
        await dispatch<any>(getUser({ userId: userId }));
      } catch (error) {
        return error;
      }
    };

    initialCall();
  }, [user]);

  return <div></div>;
};

export default Callback;
